// Shared behaviour of the POS BO pages (#443): the 503 "not installed" alert,
// error swal with pos.errors.<code>, the common report filter and xlsx export.
import swal from "sweetalert2";
import "./posTables.css";
import { utils, writeFile } from "xlsx";
import { posErrorMessage, posNotInstalledKind, posReportParams, posValidateRange, posYmd, posExportRows, posExportFileName } from "@/utils/pos";

export function posDefaultFilter() {
	const today = posYmd(new Date());
	return { range: [today, today], eventId: "", deviceId: "", includeTest: false };
}

export default {
	data() {
		return {
			// false | "phase1" | "phase3" (PosInstallAlert picks the text)
			notInstalled: false,
			loading: false
		};
	},
	methods: {
		posError(err) {
			const kind = posNotInstalledKind(err);
			if (kind) {
				this.notInstalled = kind;
				if (this.$store) this.$store.dispatch("Pos/setNotInstalled", kind);
				return;
			}
			const msg = posErrorMessage(err, (k) => this.$t(k), (k) => this.$te(k));
			swal.fire({ title: msg, icon: "error" });
		},
		posToast(key) {
			swal.fire({ title: this.$t(key), icon: "success", timer: 1500, showConfirmButton: false });
		},
		async posConfirm(text) {
			const r = await swal.fire({
				title: text,
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: this.$t("pos.common.confirm"),
				cancelButtonText: this.$t("pos.common.cancel")
			});
			return !!(r && (r.value || r.isConfirmed));
		},
		// Returns the §5.1 params or null (and shows the message) when the range is bad.
		posParams(filter) {
			const f = filter || {};
			const range = f.range || [];
			const bad = posValidateRange(range[0], range[1]);
			if (bad) {
				swal.fire({ title: this.$t(bad), icon: "warning" });
				return null;
			}
			return posReportParams(f);
		},
		// sheets = [{ name, columns:[{label,value}], rows }]
		posExport(report, params, sheets) {
			const wb = utils.book_new();
			sheets.forEach((s) => {
				const ws = utils.json_to_sheet(posExportRows(s.columns, s.rows));
				utils.book_append_sheet(wb, ws, (s.name || "Sheet1").slice(0, 31));
			});
			writeFile(wb, posExportFileName(report, params.from, params.to));
		}
	}
};
